import { render, staticRenderFns } from "./PatientDetailsList.vue?vue&type=template&id=23ddd03c&scoped=true"
import script from "./PatientDetailsList.vue?vue&type=script&lang=js"
export * from "./PatientDetailsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ddd03c",
  null
  
)

export default component.exports